import { compactTyped } from "./typed.js";
/**
 * An ICCID as typed into a path or a box: without the spaces and dashes a
 * handset's settings screen groups it with, and upper-cased because an ICCID
 * is digits and a mock's letters are capitals. Every reader of a typed ICCID
 * reads it through this, so a grouped paste names the same line everywhere.
 */
export function normalizeIccid(raw) {
    return compactTyped(raw);
}
//# sourceMappingURL=iccid.js.map